function formatData(data, contentType) {
    if (typeof data !== 'object') {
        return data;
    }
    if (contentType === 'json') {
        return JSON.stringify(data);
    }
    var arr = [];
    for (var key in data) {
        if (data.hasOwnProperty(key)) {
            arr.push("".concat(key, "=").concat(data[key]));
        }
    }
    return arr.join('&');
}
function ajax(params) {
    if (params === void 0) { params = {}; }
    var xhr = new XMLHttpRequest();
    var type = (params.type || 'GET').toUpperCase();
    var data = formatData(params.data || {}, params.contentType);
    var async = params.async === undefined ? true : params.async;
    var timeout = params.timeout || 15000;
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            var status_1 = xhr.status;
            if (status_1 >= 200 && status_1 < 300) {
                params.success && params.success(JSON.parse(xhr.responseText));
            }
            else {
                params.error && params.error(status_1, xhr.responseText);
            }
        }
    };
    xhr.ontimeout = function () {
        console.info('ajax timeout');
        params.error && params.error(arguments);
    };
    async && (xhr.timeout = timeout);
    var url = params.url;
    url += "".concat(url.indexOf('?') > -1 ? '&' : '?', "r=").concat(Math.random());
    if (type === 'GET') {
        xhr.open(type, "".concat(url, "&").concat(data), async);
        xhr.send(null);
    }
    else {
        xhr.open(type, url, async);
        xhr.setRequestHeader('Content-Type', params.contentType === 'json'
            ? 'application/json; charset=UTF-8'
            : 'application/x-www-form-urlencoded;charset=UTF-8');
        if (params.contentType === 'json') {
        }
        if (params.headers) {
            for (var key in params.headers) {
                if (Object.prototype.hasOwnProperty.call(params.headers, key)) {
                    xhr.setRequestHeader(key, params.headers[key]);
                }
            }
        }
        xhr.send(data);
    }
}
export default ajax;
//# sourceMappingURL=ajax.js.map